import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SoftwareApiService } from './software-api.service';
let SoftwareService = class SoftwareService {
    constructor(_softwareApiService) {
        this._softwareApiService = _softwareApiService;
        this.software$ = new BehaviorSubject(null);
    }
    getSoftware() {
        return this._softwareApiService.getSoftware().pipe(tap((response) => {
            this.software$.next(response);
        }));
    }
};
SoftwareService.ctorParameters = () => [
    { type: SoftwareApiService }
];
SoftwareService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SoftwareApiService])
], SoftwareService);
export { SoftwareService };
